<template>
    <b-modal hide-footer id="modalTransacaoAvulsaNovo" :title="`Nova Transação Avulsa - Pedido: #${pedido.idPedidoVindi}`" size="lg">
        <b-card v-if="pedido" title="Escolha o Produto">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Produto</label>
                            <b-select v-model="payload.produto" :options="produtos" text-field="name" value-field="id">
                                <template v-slot:first>
                                    <option :value="null">Selecione</option>
                                </template>
                            </b-select>
                            <small>{{descricaoProduto}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
        <b-card class="mt-3" v-if="isNegociacao" title="Negociação">
            <div class="container">
                <div class="row">
                    <div class="col-4">
                        <div class="form-group">
                            <label>Valor (R$)</label>
                            <money required v-model="payload.price" name="price"
                              v-validate="'required'" class="form-control" id="price" />
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Porcentagem DrAchei (%)</label>
                      <input type="number" maxlength="100" required v-model="payload.split.valorDrAchei" name="valorDrAchei"
                             v-validate="'required'" class="form-control" id="valorDrAchei" />
                      <small>Valor: {{valorDrAchei | money}}</small>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label>Porcentagem Empresa (%)</label>
                      <input type="number" maxlength="100" required v-model="payload.split.valorEmpresa" name="valorEmpresa"
                             v-validate="'required'" class="form-control" id="valorEmpresa" />
                      <small>Valor: {{valorEmpresa | money}}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Observação</label>
                            <textarea v-model="payload.observacao" class="form-control" cols="30"
                                rows="4"></textarea>
                            <small class="text-muted">Informe o que está sendo negociado e o Identificador do pedido</small>
                        </div>
                    </div>
                </div>
            </div>

            <template v-slot:footer>
                 <div class="container">
                    <div class="row d-flex justify-content-end">
                        <div class="col-4">
                            <h5>Total a Pagar: {{payload.price | money}}</h5>
                        </div>
                    </div>
                 </div>
             </template>
        </b-card>
        <b-card class="mt-3" v-if="isTaxaEmissao" title="Solicite Cartão Físico">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <small
                        class="form-text text-muted"
                        >Informe: Cada cartão físico tem um custo de emissão de R$ 12,00. E os cartões chegarão no endereço do títular</small>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-form-checkbox
                            v-model="checkedCartaoFisico"
                            name="check-button"
                            switch
                            >Títular ({{pedido.client.name}})</b-form-checkbox>
                            <b-form-checkbox
                            v-for="dep in pedido.client.dependentes"
                            :key="dep.cpf"
                            :value="dep"
                            v-model="dependentesCartaoFisico"
                            switch
                            >{{dep.name}}</b-form-checkbox>
                    </div>
                </div>
            </div>

             <template v-slot:footer>
                 <div class="container">
                    <div class="row d-flex justify-content-end">
                        <div class="col-4">
                            <h5>Total a Pagar: {{valorTotalCartaoFisico | money}}</h5>
                        </div>
                    </div>
                 </div>
             </template>
        </b-card>
        <b-card class="mt-3" title="Escolha a Forma Pagamento" v-if="produto">
            <div class="row">
                <div class="col">
                    <b-card-group deck>
                        <b-card style="cursor: pointer" title="Boleto"
                            v-if="empresa.plataformaPagamento === 'vindi'"
                            @click="formaPagamentoSelected='Boleto'"
                            :border-variant="formaPagamentoSelected === 'Boleto' ? 'success' : 'default'">
                            <div class="container">
                                <div class="row justify-content-center align-items-center">
                                    <div class="col-4">
                                        <i class="fa fa-file-invoice fa-6x"></i>
                                    </div>
                                </div>
                            </div>
                            <template v-slot:footer>
                                <div class="container">
                                    <div class="row justify-content-center align-items-center">
                                        <div class="col-4">
                                             <b-form-radio v-model="formaPagamentoSelected" name="some-radios" value="Boleto"></b-form-radio>
                                            <small class="text-muted">Escolher Boleto</small>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </b-card>

                      <template v-if="empresa.plataformaPagamento === 'vindi'">
                        <b-card style="cursor: pointer" title="Cartão Crédito" v-for="profile in profilesPagamento" :key="profile.id"

                            @click="formaPagamentoSelected=profile.id"
                            :border-variant="formaPagamentoSelected === profile.id ? 'success' : 'default'">
                                <div class="container">
                                    <div class="row justify-content-center align-items-center">
                                        <div class="col-4">
                                            <img alt="bandeira-cartao" height="120" :src="require('@/assets/images/cartao_visa.svg')">
                                        </div>
                                        <div class="col ">
                                            <h6>Número: {{profile.card_number_first_six}}XXXX{{profile.card_number_last_four}}</h6>
                                            <h6>Validade: {{formataData(profile.card_expiration)}}</h6>
                                        </div>
                                    </div>
                                </div>
                                <template v-slot:footer>
                                    <div class="container">
                                        <div class="row justify-content-center align-items-center">
                                            <div class="col-6">
                                                <b-form-radio v-model="formaPagamentoSelected" name="some-radios" :value="profile.id"></b-form-radio>
                                                <small class="text-muted">Escolher Cartão de Crédito</small>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                        </b-card>
                      </template>

                      <template v-if="empresa.plataformaPagamento === 'Pagar.me'">
                        <b-card style="cursor: pointer" title="Cartão Crédito" v-for="profile in profilesPagamento" :key="profile.id"
                                @click="formaPagamentoSelected=profile.id"
                                :border-variant="formaPagamentoSelected === profile.id ? 'success' : 'default'">
                          <div class="container">
                            <div class="row justify-content-center align-items-center">
                              <div class="col-4">
                                <img alt="bandeira-cartao" height="120" :src="require('@/assets/images/cartao_visa.svg')">
                              </div>
                              <div class="col ">
                                <h6>Número: {{profile.first_digits}}XXXX{{profile.last_digits}}</h6>
                                <h6>Validade: {{profile.expiration_date.replace(/(\d{2})(\d{2})/gi, '$1/$2')}}</h6>
                              </div>
                            </div>
                          </div>
                          <template v-slot:footer>
                            <div class="container">
                              <div class="row justify-content-center align-items-center">
                                <div class="col-6">
                                  <b-form-radio v-model="formaPagamentoSelected" name="some-radios" :value="profile.id"></b-form-radio>
                                  <small class="text-muted">Escolher Cartão de Crédito</small>
                                </div>
                              </div>
                            </div>
                          </template>
                        </b-card>
                      </template>
                    </b-card-group>
                </div>
            </div>

            <template v-slot:footer>
                <b-button @click="comprar" variant="primary" :disabled="!formaPagamentoSelected || !produto">Gerar</b-button>
            </template>
        </b-card>



    </b-modal>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        pedido: {
            type: Object,
            required: true
        }
    },
    computed: {
        produto() {
            return this.produtos.find(prod => prod.id === this.payload.produto);
        },
        isProdutoPorUnidade() {
            return this.payload.produto && this.produto.pricing_schema.schema_type === 'per_unit';
        },
        isTaxaEmissao() {
            return this.payload.produto && this.produto.code === 'taxaEmissaoCartao';
        },
        isNegociacao() {
            return this.payload.produto && this.produto.code === 'negociacao';
        },
        descricaoProduto() {
            return this.payload.produto && this.produto.pricing_schema.short_format;
        },
        qtdSolicitacao() {
            if (this.checkedCartaoFisico) {
                return this.dependentesCartaoFisico.length + 1;
            } else {
                return this.dependentesCartaoFisico.length
            }
        },
        valorTotalCartaoFisico() {
            return Number(this.produto.pricing_schema.price) * this.qtdSolicitacao;
        },
        empresa() {
            return this.$store.getters.empresa || {};
        },
        valorDrAchei() {
          if (this.payload.split.valorDrAchei && this.payload.price) {
            return this.payload.price * (this.payload.split.valorDrAchei / 100);
          }
          return 0;
        },
        valorEmpresa() {
          if (this.payload.split.valorEmpresa && this.payload.price) {
            return this.payload.price * (this.payload.split.valorEmpresa / 100);
          }
          return 0;
        }
    },
    data() {
        return {
            formaPagamentoSelected: null,
            produtos: [],
            profilesPagamento: [],
            payload: {
                produto: null,
                price: 0,
                observacao: null,
                split: {}
            },
            checkedCartaoFisico: true,
            dependentesCartaoFisico: []
        }
    },
    async mounted() {
        this.payload = {
            produto: null,
            price: 0,
            observacao: null,
            split: {}
        };
        this.formaPagamentoSelected = null;

        if (this.pedido.plano.porcentagemRepasseDrAchei) {
          this.payload.split.valorDrAchei = this.pedido.plano.porcentagemRepasseDrAchei;
        }
        if (this.pedido.plano.porcentagemRepasseEmpresa) {
          this.payload.split.valorEmpresa = this.pedido.plano.porcentagemRepasseEmpresa;
        }

        const response = await axios.get(`/api/saude/faturaAvulsa/produtos?idEmpresa=${this.empresa._id}`);
        this.produtos = response.data;

        await this.getProfilePagamento();
    },
    methods: {
      async getProfilePagamento() {
        if (this.pedido) {
          // eslint-disable-next-line no-console
          console.log('pedido', this.pedido);
          // eslint-disable-next-line no-console
          console.log('idPpedido', this.pedido._id);
          const response = await axios.get(`/api/client/profileCreditCard?idEmpresa=${this.empresa._id}&idPedido=${this.pedido._id}`);
          this.profilesPagamento = response.data;
        }
      },
      formataData(value) {
        if (!value) return '';
        return moment(value).format("MM/YYYY");
      },
      clearValues(){
          this.formaPagamentoSelected = null;
          this.dependentesCartaoFisico = [];
      },
        async comprar() {
            let body = {
                    "customer_id": this.pedido.client.idClienteVindi,
                    "payment_method_code": this.formaPagamentoSelected === 'Boleto' ? 'Boleto' : 'credit_card',
                    };
            if (this.formaPagamentoSelected !== 'Boleto') {
                body.payment_profile = {};
                body.payment_profile.id = this.formaPagamentoSelected;
            }

            if (this.produto) {
                body.bill_items = [];
                body.bill_items.push({
                    "product_id": this.produto.id,
                    "amount": this.isNegociacao ? this.payload.price : this.valorTotalCartaoFisico,
                    "description": this.payload.observacao
                });
            }

            if (this.payload.split) {
              body.split = this.payload.split;
            }

            if(this.isTaxaEmissao) {
                body.quantity = this.qtdSolicitacao;
                body.pricing_schema = {
                    price: this.produto.pricing_schema.price,
                    schema_type: this.produto.pricing_schema.schema_type
                }
                body.cartoes = this.dependentesCartaoFisico;
                if (this.checkedCartaoFisico) {
                    body.cartoes.push({
                        name: this.pedido.client.name,
                        isTitular: true
                    });
                }
            }

            this.$store.dispatch('setLoading', true);

            const response = await axios.post(`/api/saude/faturaAvulsa?idEmpresa=${this.pedido.juridica._id}&pedido=${this.pedido._id}`, body);
            const faturaAvulsa = response.data;

            this.$store.dispatch('setLoading', false);

            this.$bvModal.hide('modalTransacaoAvulsaNovo');

            if (faturaAvulsa.urlBoleto) {
                window.open(faturaAvulsa.urlBoleto);
            }

        }
    }
}
</script>
